import {
  PMSmallNumber,
  PMSmallNumberCardEditSchema,
} from "@pimo/pimo-components/src/lib/pm-components";

import { getLocalizedCardCopy } from "../../../utils/get-localized-card-copy";
import {
  getItemName,
  getPluralOfItemName,
} from "../../../utils/get-plural-of-item-name";
import { DashboardCardContext } from "../context";

export function addNumberOfTrackingItemsCard(ctx: DashboardCardContext) {
  const { view, language, projectName, projectNamePlural, getCardCopy } = ctx;

  const numberOfTrackingItemsComponent = view.addComponent({
    component: PMSmallNumber,
    layoutProps: {
      componentId: "numberOfTrackingItemsComponent",
      title: "",
      description: "",
      labels: ["#ofTrackingItems"],
      editSchema: PMSmallNumberCardEditSchema,
    },
  });

  numberOfTrackingItemsComponent.mapLayoutProps(() => {
    return {
      componentId: "numberOfTrackingItemsComponent",
      labels: ["#ofTrackingItems"],
      description: getCardCopy(language, "numberOfItems").description,
      title: getCardCopy(language, "numberOfItems").title,
      editSchema: PMSmallNumberCardEditSchema,
    };
  });

  numberOfTrackingItemsComponent.mapState((appState) => {
    return {
      title: getLocalizedCardCopy(appState.language, "numberOfItems", {
        itemName: getItemName(
          appState.settings?.configuration?.itemName,
          appState.language
        ),
        itemNamePlural: getPluralOfItemName(
          appState.settings?.configuration?.itemName,
          appState.language
        ),
        projectName,
        projectNamePlural,
      }).title,
      number: appState?.dashboard?._calculated?.numberOfSubEntities ?? 0,
    };
  });
}
